<template>
  <div class="card-group horizontal"
       id="accordion"
       role="tablist"
       aria-multiselectable="true">
    <div class="card card-default m-b-0">
      <div class="card-header" role="tab" id="refusedCandidatesHeading">
        <h4 class="card-title">
          <a data-toggle="collapse"
             data-parent="#accordion"
             href="#refusedCandidates"
             aria-expanded="false"
             aria-controls="collapseOne"
             class="collapsed">
            {{ $t('Offer.refusedCandidates') }}
            <span>({{ this.candidatesCount }})</span>
          </a>
        </h4>
      </div>

      <div id="refusedCandidates"
           class="collapse"
           role="tabcard"
           aria-labelledby="headingOne">
        <div class="card-body">
          <ul>
            <li v-for="candidate in candidates">
              <span class="firstname">{{ candidate.first_name }}</span>
              <span class="lastname">{{ candidate.last_name }}</span>
              <span class="lastname">( {{ candidate.email }} )</span>
              <span class="overlap text-secondary" v-if="overlapCandidateIds.includes(candidate.id)">
                {{ $t('Offer.candidate_overlap') }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    name: 'RefusedCandidates',
    props: ["candidates", "overlapCandidateIds"],
    computed: {
      candidatesCount() {
        return this.candidates.length
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/offers/RefusedCandidates.vue